import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { Modal, Form, Button, Radio, Dropdown, Icon, Input, Grid, Table, Segment, Header, TextArea, Transition, Message, Container, Popup } from 'semantic-ui-react';
import { SemanticToastContainer, toast } from 'react-semantic-toasts';
import 'react-semantic-toasts/styles/react-semantic-alert.css';
import { getOrders, showLoading, hideLoading, getCustomers, getProductMaterials, verifyVoucher, clearVoucher, openCustomModal } from '../actions';
import { serverURI } from '../config';
import '../App.css';

const request = require('superagent');

// helper function to reorder item
class GetProduct extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            page: 0,
            orderingPage: 'productForm',
            shipping: 'Self Collect',
            address: "",
            company: "",
            searchValue: "",
            searchQuery: '',
            selected_customer: null,
            coveropt: [],
            inneropt: [],
            configurations: {},
            voucher_code: '',
            subtotal: 0.0,
            voucherDiscount: 0.0,
            shipping_fee: 0.0,
            total_amount: 0.0,
            data_sync: 0,
            submitting: false
        };
    }

    componentWillMount() {
        this.props.showLoading('Retrieving data . . . ');
        this.props.getCustomers();
        this.props.getProductMaterials();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.customer.list && (this.props.customer.list !== nextProps.customer.list)) {
            let customeroption = nextProps.customer.list.map(obj => {
                let newObj = { key: obj.email, value: obj.email, text: obj.name + "  (" + obj.email + ")" };
                return newObj;
            });
            this.setState({ data: _.chunk(nextProps.customer.list), customeroption, data_sync: this.state.data_sync + 1 });
            if (this.state.data_sync > 0) this.props.hideLoading();
        }

        if ((nextProps.product.materials.length > 0) && (this.props.product.materials !== nextProps.product.materials)) {
            let product = nextProps.product.materials.find((prod) => prod.name === 'Digital Booklet');
            let coveropt = product.cover_material.values.map((el) => ({key: el, value: el, text: el}));
            let inneropt = product.inner_material.values.map((el) => ({key: el, value: el, text: el}));
            this.setState({
                coveropt: coveropt,
                inneropt: inneropt,
                data_sync: this.state.data_sync + 1
            });
            if (this.state.data_sync > 0) this.props.hideLoading();
        }

        if (nextProps.order.voucher_discount && (nextProps.order.voucher_discount !== this.props.order.voucher_discount)) {
            if (nextProps.order.voucher_discount.type === 'error') {
                toast({
                    type: 'error',
                    icon: 'exclamation triangle',
                    title: 'Apply Voucher Failed',
                    description: nextProps.order.voucher_discount.value,
                    animation: 'fade',
                    time: 5000,
                });
            } else {
                let discount = this.calculateDiscount(nextProps.order.voucher_discount, this.state.subtotal);
                let total_amount = this.state.subtotal + this.state.shipping_fee;
                this.setState({ voucherDiscount: discount, total_amount });
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.configurations.price !== prevState.configurations.price) {
            let discount = this.calculateDiscount(this.props.order.voucher_discount, this.state.configurations.price);
            let total_amount = this.state.configurations.price + this.state.shipping_fee;
            this.setState({ subtotal: this.state.configurations.price, voucherDiscount: discount, total_amount });
        }

        if ((this.state.orderingPage !== prevState.orderingPage) && (this.state.orderingPage === 'ackForm')) {
            this.props.hideLoading();
        }

        if (this.state.selected_customer !== prevState.selected_customer) {
            this.props.clearVoucher();
        }
    }

    componentWillUnmount() {
        this.props.clearVoucher();
    }

    handleButton = (title) => {
        console.log('Open ' + title);
        this.setState({ orderingPage: title });
    }

    handleInputChange = (e, data) => {
        if (data.name === 'product') {
            this.setState({ product: data.value });
            return;
        }

        let newConfig = { ...this.state.configurations };
        if (data.type === 'number') {
            if (data.value.length === 0) {
                newConfig[data.name] = 0;
            } else {
                let value = parseFloat(data.value);
                if (Number.isInteger(value)) {
                    newConfig[data.name] = parseInt(data.value);
                } else {
                    newConfig[data.name] = value;
                }
            }
        } else {
            newConfig[data.name] = data.value;
        }

        console.log(newConfig);
        this.setState({ configurations: newConfig });
    }

    handleDropdownInput = (e, data) => {
        let configurations = this.state.configurations;
        configurations[data.name] = data.value;
        console.log(configurations);
        this.setState({ configurations });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        let product, configurations;

        if (this.state.orderingPage === 'productForm') {
            if (this.props.formType === 'bookletForm') {
                product = 'Digital Booklet';
            } else {
                product = _.startCase(e.target.elements['product'].value);
            }
            this.setState({ product, orderingPage: 'customerForm'});
        } else if (this.state.orderingPage === 'customerForm') {
            console.log('Customer Form');
            console.log(this.state.selected_customer);
            console.log(this.state.configurations);
            let order = {
                customer: {
                    ...this.state.selected_customer,
                    phone: this.state.selected_customer.mobile,
                    _id: undefined,
                    balance: undefined,
                    createdAt: undefined,
                    provider: undefined,
                    status: undefined,
                    mobile: undefined
                },
                recipient: (this.state.shipping === 'Shipping Address') ?
                {
                    name: e.target.elements['shipping_name'].value.trim().toUpperCase(),
                    address: {
                        address_1: e.target.elements['shipping_address_1'].value.trim().toUpperCase(),
                        address_2: e.target.elements['shipping_address_2'].value.trim().toUpperCase(),
                        town_city: e.target.elements['shipping_town_city'].value.trim().toUpperCase(),
                        postcode: e.target.elements['shipping_postcode'].value.trim().toUpperCase(),
                        state: e.target.elements['shipping_state'].value.trim().toUpperCase(),
                        country: e.target.elements['shipping_country'].value.trim().toUpperCase()
                    },
                    phone: e.target.elements['shipping_phone'].value.trim()
                } : null,
                items:
                    [{
                        product: this.state.product,
                        configurations: {
                            ...this.state.configurations,
                            price: undefined,
                            remarks: undefined
                        },
                        price: this.state.configurations.price,
                        duration: this.state.configurations.duration
                    }],
                process_days: this.state.configurations.duration,
                delivery_option: (this.state.shipping === 'Self Collect') ? 'SELF COLLECT' : 'COURIER',
                subtotal: this.state.subtotal,
                shipping_fee: this.state.shipping_fee,
                shipping_disc: 0,
                voucher_code: this.state.voucher_code,
                total_amount: this.state.total_amount,
                notes: (this.state.configurations.remarks) ? this.state.configurations.remarks.trim() : '',
                payment_method: 'In-Store Credit'
            }

            let trxn = {
                user: {
                    _id: this.state.selected_customer._id,
                    provider: this.state.selected_customer.provider
                },
                order_details: order
            }

            console.log(trxn);
            this.setState({ submitting: true });
            this.completeSubmitOrder(trxn);
        }
    }

    async completeSubmitOrder(trxn) {
        this.props.showLoading('Submitting order . . . ');

        try {
            let resp = await request.post(serverURI + '/v1/commit_order')
                .set('Content-Type', 'application/json')
                .send(trxn);
            if (resp.status === 200) {
                this.props.hideLoading();
                this.setState({ orderingPage: 'ackForm' });
            } else {
                // const alert = this.props.alert.show('Failed to submit order. Please try again!', {
                //     timeout: 3000,
                //     type: 'error',
                // });

                // this.setState({ submitting: false });
                toast({
                    type: 'error',
                    icon: 'exclamation triangle',
                    title: 'Order Submission Failed',
                    description: 'Failed to submit order. Please try again!',
                    animation: 'fade',
                    time: 5000,
                });
            }
        } catch (err) {
            console.log(err);
            // const alert = this.props.alert.show(err.response.text, {
            //     timeout: 3000,
            //     type: 'error',
            // });

            // let balance_alert = (err.response.text.toUpperCase().includes('INSUFFICIENT BALANCE')) ? true : false;

            // this.setState({ submitting: false, balance_alert });

            toast({
                type: 'error',
                icon: 'exclamation triangle',
                title: 'Order Submission Failed',
                description: err.response.text,
                animation: 'fade',
                time: 5000,
            });
        }
    }

    closeModal() {
        this.setState({ orderingPage: 'none' });
    }

    handleShippingChange = (e, { value }) => {
        console.log('option' + value);
        this.setState({ shipping: value });
    }

    handleShippingFeeChange = (e) => {
        let shipping_fee = 0;
        let total_amount = 0;
        if (e.target.value.length > 0) {
            shipping_fee = parseFloat(e.target.value);
        }
        total_amount = this.state.subtotal + shipping_fee;
        this.setState({ shipping_fee, total_amount });
    }

    handleCreateOrderModalInput(event) {
        var elementId = event.target.id;
        var elementValue = event.target.value;

        var newState = {};

        newState[elementId] = elementValue;
        this.setState(newState);
    }

    handleChange = (e, { value }) => {
        console.log('handleChange: ' + value); // Get Value (Email) From Customer List  & Show Name and Email as text
        this.setState({ searchValue: value });

        //Dropdown Options List 8
        let customer_list;
        customer_list = this.props.customer.list;

        let customeroption = customer_list.map(obj => {
            let newObj = { key: obj.email, value: obj.email, text: obj.name + "(" + obj.email + ")" };
            return newObj;

        });

        //Input Value find most nearest email / name
        var selected_customer = this.props.customer.list.find(function (element) {
            return element.email === value;
        });


        // Show value at Form
        this.setState({ selected_customer });
        console.log(selected_customer.company);
    }

    handleApplyCode(e) {
        e.preventDefault();
        console.log(this.state.selected_customer);
        console.log(this.state.voucher_code);
        this.props.verifyVoucher(this.state.selected_customer._id, this.state.voucher_code);
    }

    calculateDiscount(voucher, amount) {
        let discount = 0;
        console.log(voucher);
        console.log(amount);

        if (voucher && voucher.type !== 'error') {
            discount = (voucher.type === 'cash') ? (voucher.value) : (amount * voucher.value / 100.0);
        }

        return discount;
    }

    render() {
        const { orderingPage, searchValue, customeroption, selected_customer, coveropt, inneropt, product, configurations, subtotal, voucherDiscount, total_amount, submitting } = this.state;
        const { formType, order } = this.props;
        let display_total = total_amount - voucherDiscount;

        return (
            <Fragment>
                <SemanticToastContainer />
                <Modal open={true} closeIcon closeOnDimmerClick={false} closeOnEscape={false} onClose={() => this.props.openCustomModal(false)}>
                    <Modal.Header>
                        {
                            ((orderingPage === 'productForm') &&
                                (<Header as='h2' color='red'>
                                    <Icon name={(formType === 'bookletForm') ? 'book' : 'archive'} />
                                    <Header.Content>
                                    { (formType === 'bookletForm') ? 'Booklet' : 'General' }
                                    <Header.Subheader>Product Specification</Header.Subheader>
                                    </Header.Content>
                                </Header>
                                )
                            )
                        }

                        {
                            ((orderingPage === 'customerForm') &&
                                <Header as='h2' color='red'>
                                    <Icon name='file alternate' />
                                    <Header.Content>
                                        Billing Details
                                    </Header.Content>
                                </Header>
                            )
                        }
                        {
                            ((orderingPage === 'ackForm') &&
                                <Header as='h2' color='red'>
                                    <Icon name='shipping fast' />
                                    <Header.Content>
                                        <h2>Submission Complete</h2>
                                    </Header.Content>
                                </Header>
                            )
                        }
                    </Modal.Header>
                    <Modal.Content >
                        {
                            ((orderingPage === 'productForm') &&
                                ((formType === 'bookletForm') ?
                                ( <Form onSubmit={this.handleSubmit.bind(this)} >
                                        <Form.Group inline>
                                            <Form.Field inline width={3}>
                                                <label style={{ fontSize: '15px' }} >Book Open Size</label>
                                            </Form.Field>
                                            <Form.Field width={6}>
                                                <Input
                                                    label={{ basic: true, content: 'mm' }}
                                                    labelPosition='right'
                                                    placeholder='Width'
                                                    type='number'
                                                    min='0'
                                                    name='open_width'
                                                    defaultValue={this.state.configurations.open_width}
                                                    onChange={this.handleInputChange}
                                                />
                                            </Form.Field>
                                            <Form.Field width={6}>
                                                <Input
                                                    label={{ basic: true, content: 'mm' }}
                                                    labelPosition='right'
                                                    placeholder='Height'
                                                    type='number'
                                                    min='0'
                                                    name='open_height'
                                                    defaultValue={this.state.configurations.open_height}
                                                    onChange={this.handleInputChange.bind(this)}
                                                />
                                            </Form.Field>
                                        </Form.Group>

                                        <Form.Group inline >
                                            <Form.Field inline width={3} >
                                                <label style={{ fontSize: '15px' }} >Book Closed Size</label>
                                            </Form.Field>
                                            <Form.Field width={6}>
                                                <Input
                                                    label={{ basic: true, content: 'mm' }}
                                                    labelPosition='right'
                                                    placeholder='Width'
                                                    type='number'
                                                    min='0'
                                                    name='closed_width'
                                                    defaultValue={this.state.configurations.closed_width}
                                                    onChange={this.handleInputChange.bind(this)}
                                                />
                                            </Form.Field>
                                            <Form.Field width={6}>
                                                <Input
                                                    label={{ basic: true, content: 'mm' }}
                                                    labelPosition='right'
                                                    placeholder='Height'
                                                    type='number'
                                                    min='0'
                                                    name='closed_height'
                                                    defaultValue={this.state.configurations.closed_height}
                                                    onChange={this.handleInputChange.bind(this)}
                                                />
                                            </Form.Field>
                                        </Form.Group>

                                        <Form.Group inline >
                                            <Form.Field inline width={3} >
                                                <label style={{ fontSize: '15px' }} >Book Binding </label>
                                            </Form.Field>
                                            <Form.Field width={6}>
                                                <Input
                                                    placeholder='Book Binding'
                                                    type='text'
                                                    name='binding'
                                                    defaultValue={this.state.configurations.binding}
                                                    onChange={this.handleInputChange.bind(this)}
                                                />
                                            </Form.Field>
                                            {/* <Form.Field required>
                                                <Dropdown name='binding' placeholder='Book Binding' selection options={bindopt} value={this.state.configurations.binding} onChange={this.handleDropdownInput} />
                                            </Form.Field> */}
                                        </Form.Group>

                                        <Form.Group inline >
                                            <Form.Field inline width={3} >
                                                <label style={{ fontSize: '15px' }} >Quantity</label>
                                            </Form.Field>
                                            <Form.Field width={6}>
                                                <Input
                                                    label={{ basic: true, content: 'bks' }}
                                                    labelPosition='right'
                                                    placeholder='Quantity'
                                                    type='number'
                                                    min='0'
                                                    name='quantity'
                                                    defaultValue={this.state.configurations.quantity}
                                                    onChange={this.handleInputChange.bind(this)}
                                                    required
                                                />
                                            </Form.Field>
                                        </Form.Group>

                                        <Form.Group inline >
                                            <Form.Field inline width={3} >
                                                <label style={{ fontSize: '15px' }} >Cover </label>
                                            </Form.Field>
                                            <Form.Field>
                                                <Dropdown name='cover_material' placeholder='Cover Material' selection options={coveropt} onChange={this.handleDropdownInput} value={this.state.configurations.cover_material} />
                                            </Form.Field>
                                        </Form.Group>

                                        <Form.Group inline >
                                            <Form.Field inline width={3} >
                                                <label style={{ fontSize: '15px' }} >Print Colour</label>
                                            </Form.Field>
                                            <Form.Field>
                                                <Dropdown name='print_colour' placeholder='Print Colour' selection options={printopt} onChange={this.handleDropdownInput} value={this.state.configurations.print_colour} />
                                            </Form.Field>
                                        </Form.Group>

                                        <Form.Group inline >
                                            <Form.Field inline width={3} >
                                                <label style={{ fontSize: '15px' }} >Inner</label>
                                            </Form.Field>
                                            <Form.Field>
                                                <Dropdown name='inner_material' placeholder='Inner Material' selection options={inneropt} onChange={this.handleDropdownInput} value={this.state.configurations.inner_material} />
                                            </Form.Field>
                                        </Form.Group>

                                        <Form.Group inline >
                                            <Form.Field inline width={3}>
                                                <label style={{ fontSize: '15px' }} >Inner Pages </label>
                                            </Form.Field>
                                            <Form.Field width={6}>
                                                <Input
                                                    placeholder='Inner Pages'
                                                    type='number'
                                                    min='0'
                                                    name='inner_pages'
                                                    defaultValue={this.state.configurations.inner_pages}
                                                    onChange={this.handleInputChange.bind(this)}
                                                />
                                            </Form.Field>
                                            <p className="form-notes">
                                                * Saddle Stitching maximum pages 64pgs. <br />
                                                * Perfect Binding minimum 48pgs.
                                                 </p>
                                        </Form.Group>

                                        <Form.Group inline >
                                            <Form.Field inline width={3}>
                                                <label style={{ fontSize: '15px' }} >Cover Artwork URL</label>
                                            </Form.Field>
                                            <Form.Field width={6}>
                                                <Input
                                                    placeholder='URL'
                                                    name='cover_artwork_url'
                                                    defaultValue={this.state.configurations.cover_artwork_url}
                                                    onChange={this.handleInputChange.bind(this)}
                                                />
                                            </Form.Field>
                                        </Form.Group>

                                        <Form.Group inline >
                                            <Form.Field inline width={3}>
                                                <label style={{ fontSize: '15px' }} >Inner Artwork URL</label>
                                            </Form.Field>
                                            <Form.Field width={6}>
                                                <Input
                                                    placeholder='URL'
                                                    name='inner_artwork_url'
                                                    defaultValue={this.state.configurations.inner_artwork_url}
                                                    onChange={this.handleInputChange.bind(this)}
                                                />
                                            </Form.Field>
                                        </Form.Group>

                                        <Form.Group inline >
                                            <Form.Field inline width={3}>
                                                <label style={{ fontSize: '15px' }} >JPEG Reference URL</label>
                                            </Form.Field>
                                            <Form.Field width={6}>
                                                <Input
                                                    placeholder='URL'
                                                    name='jpeg_ref_url'
                                                    defaultValue={this.state.configurations.jpeg_ref_url}
                                                    onChange={this.handleInputChange.bind(this)}
                                                />
                                            </Form.Field>
                                        </Form.Group>

                                        <Form.Group inline >
                                            <Form.Field inline width={3} >
                                                <label style={{ fontSize: '15px' }} >Price</label>
                                            </Form.Field>
                                            <Form.Field width={6}>
                                                <Input
                                                    label={{ basic: true, content: 'RM' }}
                                                    labelPosition='left'
                                                    placeholder='Price'
                                                    type='number'
                                                    min='0'
                                                    step='0.01'
                                                    name='price'
                                                    defaultValue={this.state.configurations.price}
                                                    onChange={this.handleInputChange.bind(this)}
                                                    required
                                                />
                                            </Form.Field>
                                        </Form.Group>

                                        <Form.Group inline >
                                            <Form.Field inline width={3} >
                                                <label style={{ fontSize: '15px' }} >Process Day</label>
                                            </Form.Field>
                                            <Form.Field width={6}>
                                                <Input
                                                    placeholder='Process Day'
                                                    type='number'
                                                    min='0'
                                                    name='duration'
                                                    defaultValue={this.state.configurations.duration}
                                                    onChange={this.handleInputChange.bind(this)}
                                                />
                                            </Form.Field>
                                        </Form.Group>

                                        <Form.Group inline>
                                            <Form.Field inline width={3} >
                                                <label style={{ fontSize: '15px' }} >Remarks</label>
                                            </Form.Field>
                                            <Form.Field name='remarks' control={TextArea} width={13}
                                                    defaultValue={this.state.configurations.remarks}
                                                    onChange={this.handleInputChange.bind(this)}
                                            />
                                        </Form.Group>

                                        <Container textAlign='right'> <Button primary type="submit" >Next</Button></Container>
                                    </Form>)
                                    :
                                    ( <Form onSubmit={this.handleSubmit.bind(this)}>

                                            <Form.Group inline >
                                                <Form.Field inline width={3} >
                                                    <label style={{ fontSize: '15px' }} >General</label>
                                                </Form.Field>
                                                <Form.Field width={13}>
                                                    <Input
                                                        name='product'
                                                        placeholder='Product'
                                                        defaultValue={this.state.product}
                                                        onChange={this.handleInputChange.bind(this)}
                                                        required
                                                    />
                                                </Form.Field>
                                            </Form.Group>

                                            <Form.Group inline>

                                                <Form.Field inline width={3} >
                                                    <label style={{ fontSize: '15px' }} > Open Size</label>
                                                </Form.Field>
                                                <Form.Field width={6}>
                                                    <Input
                                                        label={{ basic: true, content: 'mm' }}
                                                        labelPosition='right'
                                                        placeholder='Width'
                                                        type='number'
                                                        min='0'
                                                        name='open_width'
                                                        defaultValue={this.state.configurations.open_width}
                                                        onChange={this.handleInputChange.bind(this)}
                                                    />
                                                </Form.Field>
                                                <Form.Field width={6}>
                                                    <Input
                                                        label={{ basic: true, content: 'mm' }}
                                                        labelPosition='right'
                                                        placeholder='Height'
                                                        type='number'
                                                        min='0'
                                                        name='open_height'
                                                        defaultValue={this.state.configurations.open_height}
                                                        onChange={this.handleInputChange.bind(this)}
                                                    />
                                                </Form.Field>
                                            </Form.Group>

                                            <Form.Group inline >
                                                <Form.Field inline width={3} >
                                                    <label style={{ fontSize: '15px' }} >Closed Size</label>
                                                </Form.Field>
                                                <Form.Field width={6}>
                                                    <Input
                                                        label={{ basic: true, content: 'mm' }}
                                                        labelPosition='right'
                                                        placeholder='Width'
                                                        type='number'
                                                        min='0'
                                                        name='closed_width'
                                                        defaultValue={this.state.configurations.closed_width}
                                                        onChange={this.handleInputChange.bind(this)}
                                                    />
                                                </Form.Field>
                                                <Form.Field width={6}>
                                                    <Input
                                                        label={{ basic: true, content: 'mm' }}
                                                        labelPosition='right'
                                                        placeholder='Height'
                                                        type='number'
                                                        min='0'
                                                        name='closed_height'
                                                        defaultValue={this.state.configurations.closed_height}
                                                        onChange={this.handleInputChange.bind(this)}
                                                    />
                                                </Form.Field>
                                            </Form.Group>

                                            <Form.Group inline >
                                                <Form.Field inline width={3} >
                                                    <label style={{ fontSize: '15px' }} >Paper Material</label>
                                                </Form.Field>
                                                <Form.Field>
                                                    <Dropdown name='material' placeholder='Paper Material' selection options={paperopt} onChange={this.handleDropdownInput} value={this.state.configurations.material} />
                                                </Form.Field>
                                            </Form.Group>

                                            <Form.Group inline>
                                                <Form.Field inline width={3} >
                                                    <label style={{ fontSize: '15px' }} >Quantity</label>
                                                </Form.Field>
                                                <Form.Field width={6}>
                                                    <Input
                                                        label={{ basic: true, content: 'pcs' }}
                                                        labelPosition='right'
                                                        placeholder='Quantity'
                                                        name='quantity'
                                                        defaultValue={this.state.configurations.quantity}
                                                        onChange={this.handleInputChange.bind(this)}
                                                        type='number'
                                                        min='0'
                                                        required
                                                    />
                                                </Form.Field>
                                            </Form.Group>

                                            <Form.Group inline >
                                                <Form.Field inline width={3} >
                                                    <label style={{ fontSize: '15px' }} >Print Colour </label>
                                                </Form.Field>
                                                <Form.Field>
                                                    <Dropdown name='print_colour' placeholder='Colour' selection options={colouropt} onChange={this.handleDropdownInput} value={this.state.configurations.print_colour} />
                                                </Form.Field>
                                            </Form.Group>

                                            <Form.Group inline >
                                                <Form.Field inline width={3} >
                                                    <label style={{ fontSize: '15px' }} >Lamination</label>
                                                </Form.Field>
                                                <Form.Field>
                                                    <Dropdown name='lamination' placeholder='Lamination' selection options={laminationopt} onChange={this.handleDropdownInput} value={this.state.configurations.lamination} />
                                                </Form.Field>
                                            </Form.Group>

                                            <Form.Group inline >
                                                <Form.Field inline width={3} >
                                                    <label style={{ fontSize: '15px' }} >Folding</label>
                                                </Form.Field>
                                                <Form.Field>
                                                    <Dropdown name='folding' placeholder='Folding' selection options={opt} onChange={this.handleDropdownInput} value={this.state.configurations.folding} />
                                                </Form.Field>
                                            </Form.Group>

                                            <Form.Group inline >
                                                <Form.Field inline width={3} >
                                                    <label style={{ fontSize: '15px' }} >Spot UV</label>
                                                </Form.Field>
                                                <Form.Field>
                                                    <Dropdown name= 'spot_uv' placeholder='Spot UV' selection options={opt} onChange={this.handleDropdownInput} value={this.state.configurations.spot_uv} />
                                                </Form.Field>
                                            </Form.Group>

                                            <Form.Group inline >
                                                <Form.Field inline width={3} >
                                                    <label style={{ fontSize: '15px' }} >Hot Stamping Colour </label>
                                                </Form.Field>
                                                <Form.Field>
                                                    <Dropdown name='hot_stamping_colour' placeholder='Hot Stamping Colour' selection options={hotstampopt} onChange={this.handleDropdownInput} value={this.state.configurations.hot_stamping_colour} />
                                                </Form.Field>
                                            </Form.Group>

                                            <Form.Group >
                                                <label>
                                                    * 1 side only (Front or Back)
                                                    * 6 colours available: Black, Blue, Gold, Green, Red, Silver (Max. 2 colours)</label>
                                            </Form.Group>

                                            <Form.Group inline >
                                                <Form.Field inline width={3} >
                                                    <label style={{ fontSize: '15px' }} >Round Corner</label>
                                                </Form.Field>
                                                <Form.Field>
                                                    <Dropdown name='round_corner' placeholder='Round Corner' selection options={opt} onChange={this.handleDropdownInput} value={this.state.configurations.round_corner} />
                                                </Form.Field>
                                            </Form.Group>

                                            <Form.Group inline >
                                                <Form.Field inline width={3} >
                                                    <label style={{ fontSize: '15px' }} >Hole Punching</label>
                                                </Form.Field>
                                                <Form.Field>
                                                    <Dropdown name='hold_punching' placeholder='Hole Punching' selection options={opt} onChange={this.handleDropdownInput} value={this.state.configurations.hold_punching} />
                                                </Form.Field>
                                            </Form.Group>


                                            <Form.Group inline>
                                                <Form.Field inline width={3} >
                                                    <label style={{ fontSize: '15px' }} > Artwork URL</label>
                                                </Form.Field>
                                                <Form.Field width={6}>
                                                    <Input
                                                        name='artwork_url'
                                                        defaultValue={this.state.configurations.artwork_url}
                                                        onChange={this.handleInputChange.bind(this)}
                                                        placeholder='URL'
                                                    />
                                                </Form.Field>
                                            </Form.Group>

                                            <Form.Group inline >
                                                <Form.Field inline width={3} >
                                                    <label style={{ fontSize: '15px' }} >Price</label>
                                                </Form.Field>
                                                <Form.Field width={6}>
                                                    <Input
                                                        label={{ basic: true, content: 'RM' }}
                                                        labelPosition='left'
                                                        placeholder='Price'
                                                        name='price'
                                                        defaultValue={this.state.configurations.price}
                                                        onChange={this.handleInputChange.bind(this)}
                                                        type='number'
                                                        min='0'
                                                        step='0.01'
                                                        required
                                                    />
                                                </Form.Field>
                                            </Form.Group>

                                            <Form.Group inline >
                                                <Form.Field inline width={3} >
                                                    <label style={{ fontSize: '15px' }} >Process Day</label>
                                                </Form.Field>
                                                <Form.Field width={6}>
                                                    <Input
                                                        placeholder='Process Day'
                                                        name='duration'
                                                        defaultValue={this.state.configurations.duration}
                                                        onChange={this.handleInputChange.bind(this)}
                                                        type='number'
                                                        min='0'
                                                    />
                                                </Form.Field>
                                            </Form.Group>

                                            <Form.Group inline>
                                                <Form.Field inline width={3} >
                                                    <label style={{ fontSize: '15px' }} >Remarks</label>
                                                </Form.Field>
                                                <Form.Field name='remarks' control={TextArea} width={13}
                                                    defaultValue={this.state.configurations.remarks}
                                                    onChange={this.handleInputChange.bind(this)}
                                                />
                                            </Form.Group>
                                            <Container textAlign='right'> <Button primary type="submit">Next</Button> </Container>
                                        </Form>)
                                )
                            )
                            }
                            {
                                ((orderingPage === 'customerForm') &&
                                <Fragment>
                                    <Form onSubmit={this.handleSubmit.bind(this)}>
                                        <Form.Group >
                                            <Form.Field inline width={2}>
                                                <label style={{ fontSize: '15px', padding: '8px 0px' }} >Name</label>
                                            </Form.Field>
                                            <Form.Select className="DropStyle" search value={searchValue} onChange={this.handleChange} options={customeroption} />
                                        </Form.Group>

                                        <Form.Group inline>
                                            <Form.Field inline width={2} >
                                                <label style={{ fontSize: '15px' }} >Company</label>
                                            </Form.Field>
                                            <Form.Field inline width={14} >
                                                <Input id='company' placeholder="Company" value={selected_customer ? selected_customer.company : ''} readOnly />
                                            </Form.Field>
                                        </Form.Group>

                                        <Form.Group inline >
                                            <Form.Field inline width={2} >
                                                <label style={{ fontSize: '15px' }} >Address</label>
                                            </Form.Field>
                                            <Form.Field inline width={14} >
                                                <Input id='address' placeholder="Address 1" name="address" value={selected_customer ? selected_customer.address.address_1 : ''} readOnly />
                                            </Form.Field>
                                        </Form.Group>

                                        <Form.Group inline >
                                            <Form.Field inline width={2} >
                                            </Form.Field>
                                            <Form.Field width={14}>
                                                <Input placeholder="Address 2" value={selected_customer ? selected_customer.address.address_2 : ''} readOnly />
                                            </Form.Field>
                                        </Form.Group>

                                        <Form.Group inline >
                                            <Form.Field inline width={2} >
                                            </Form.Field>
                                            <Form.Field inline width={5} >
                                                <Input placeholder="City" value={selected_customer ? selected_customer.address.town_city : ''} readOnly />
                                            </Form.Field>
                                            <Form.Field inline width={4} >
                                                <Input placeholder="Post Code" value={selected_customer ? selected_customer.address.postcode : ''} readOnly />
                                            </Form.Field>
                                            <Form.Field inline width={5} >
                                                <Input placeholder="State" value={selected_customer ? selected_customer.address.state : ''} readOnly />
                                            </Form.Field>
                                        </Form.Group>

                                        <Form.Group inline >
                                            <Form.Field inline width={2} >
                                                <label style={{ fontSize: '15px' }} >Country</label>
                                            </Form.Field>
                                            <Form.Field inline width={14} >
                                                <Input placeholder="Country" value={selected_customer ? selected_customer.address.country : ''} readOnly />
                                            </Form.Field>
                                        </Form.Group>

                                        <Form.Group inline >
                                            <Form.Field inline width={2} >
                                                <label style={{ fontSize: '15px' }} >Phone</label>
                                            </Form.Field>
                                            <Form.Field inline width={5} >
                                                <Input placeholder="Phone" value={selected_customer ? selected_customer.mobile : ''} readOnly />
                                            </Form.Field>
                                            <Form.Field inline width={1}>
                                                <label style={{ fontSize: '15px' }} >Email</label>
                                            </Form.Field>
                                            <Form.Field inline width={8} >
                                                <Input placeholder="Email" value={selected_customer ? selected_customer.email : ''} readOnly />
                                            </Form.Field>
                                        </Form.Group>

                                        <Form.Group inline >
                                            <Form.Field inline width={2}>
                                                <label style={{ fontSize: '15px' }} >Delivery</label>
                                            </Form.Field>
                                            <Form.Field inline width={14}>
                                                <Dropdown name='shipping' placeholder='Shipping Option' selection options={shippingopt} defaultValue={shippingopt[0].value} onChange={this.handleShippingChange} />
                                            </Form.Field>
                                        </Form.Group>

                                        <br></br>
                                        <Transition.Group duration={200} divided="true" size='huge' animation='slide down'>
                                            {(this.state.shipping === 'Shipping Address') && (
                                                <div>
                                                    <Header as='h2' color='red'>
                                                        <Header.Content>
                                                            Shipping Address
                                                        </Header.Content>
                                                    </Header>

                                                    <Form.Group inline>
                                                        <Form.Field width={2}>
                                                            <label style={{ fontSize: '15px' }} >Name</label>
                                                        </Form.Field>
                                                        <Form.Field width={14} >
                                                            <Input name='shipping_name' placeholder="Name" required />
                                                        </Form.Field>
                                                    </Form.Group>

                                                    <Form.Group inline>
                                                        <Form.Field width={2} >
                                                            <label style={{ fontSize: '15px' }} >Address</label>
                                                        </Form.Field>
                                                        <Form.Field width={14}>
                                                            <Input name='shipping_address_1' placeholder="Address 1" required />
                                                        </Form.Field>
                                                    </Form.Group>

                                                    <Form.Group inline>
                                                        <Form.Field width={2} >
                                                            <label > </label>
                                                        </Form.Field>
                                                        <Form.Field width={14}>
                                                            <Input name='shipping_address_2' placeholder="Address 2" />
                                                        </Form.Field>
                                                    </Form.Group>

                                                    <Form.Group inline >
                                                        <Form.Field inline width={2} >
                                                        </Form.Field>
                                                        <Form.Field inline width={5} >
                                                            <Input name='shipping_town_city' placeholder="City" required />
                                                        </Form.Field>
                                                        <Form.Field inline width={4} >
                                                            <Input name='shipping_postcode' type='number' placeholder="Post Code" max='99999' required />
                                                        </Form.Field>
                                                        <Form.Field inline width={5} >
                                                            <Input name='shipping_state' placeholder="State" required />
                                                        </Form.Field>
                                                    </Form.Group>

                                                    <Form.Group inline>
                                                        <Form.Field width={2} >
                                                            <label > </label>
                                                        </Form.Field>
                                                        <Form.Field width={14}>
                                                            <Input name='shipping_country' placeholder="Country" required />
                                                        </Form.Field>
                                                    </Form.Group>

                                                    <Form.Group inline >
                                                        <Form.Field inline width={2} >
                                                            <label style={{ fontSize: '15px' }} >Phone</label>
                                                        </Form.Field>
                                                        <Form.Field inline width={14} >
                                                            <Input name='shipping_phone' type='number' placeholder="Phone" />
                                                        </Form.Field>
                                                    </Form.Group>
                                                </div>
                                            )}
                                        </Transition.Group>
                                        <br/><br/>
                                        <Header as='h2' color='red'>
                                            <Icon name='file' />
                                            <Header.Content>
                                                Order Details
                                            </Header.Content>
                                        </Header>

                                        <Table>
                                            <Table.Header style={{ background: 'white' }}>
                                                <Table.Row>
                                                    <Table.HeaderCell style={{ fontWeight: '900', background: 'white' }}>Product</Table.HeaderCell>
                                                    <Table.HeaderCell style={{ fontWeight: '900', background: 'white' }}>Total (RM)</Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>

                                            <Table.Body >
                                                <Table.Row>
                                                    <Table.Cell width={10}>
                                                        <b>{product}</b>
                                                        <Table size='small' compact='very' striped>
                                                            <Table.Body>
                                                                {
                                                                    Object.entries(configurations).map((field) => {
                                                                        if (field[0] !== 'price')
                                                                        return (
                                                                        <Table.Row key={field[0]}>
                                                                            <Table.Cell>
                                                                                {_.startCase(field[0])}
                                                                            </Table.Cell>
                                                                            <Table.Cell>
                                                                                {field[1]}
                                                                            </Table.Cell>
                                                                        </Table.Row>
                                                                    )})
                                                                }
                                                            </Table.Body>
                                                        </Table>
                                                    </Table.Cell>
                                                    <Table.Cell width={6}>{configurations.price.toFixed(2)}</Table.Cell>
                                                </Table.Row>
                                            </Table.Body>
                                            <Table.Footer  >
                                                <Table.Row>
                                                    <Table.HeaderCell >Subtotal</Table.HeaderCell>
                                                    <Table.HeaderCell >RM {subtotal.toFixed(2)}</Table.HeaderCell>
                                                </Table.Row>
                                                {
                                                    (!order.voucher_discount || (order.voucher_discount.type === 'error')) ?
                                                    <Table.Row >
                                                        <Table.HeaderCell>Promo Code</Table.HeaderCell>
                                                        <Table.HeaderCell>
                                                            <Popup
                                                                trigger={<Input name='voucher_code' error={(order.voucher_discount && (order.voucher_discount.type === 'error'))} onChange={(e, data) => this.setState({voucher_code: data.value})} placeholder='Voucher Code' />}
                                                                content={(order.voucher_discount && (order.voucher_discount.type==='error')) ? order.voucher_discount.value : 'Please select customer'}
                                                                style={{opacity: 0.8}}
                                                                disabled={selected_customer}
                                                                inverted
                                                            />
                                                            <Button content='Apply' width={4} onClick={this.handleApplyCode.bind(this)} disabled={!selected_customer || (this.state.voucher_code.length === 0)} />
                                                        </Table.HeaderCell>
                                                    </Table.Row> :
                                                    <Table.Row>
                                                        <Table.HeaderCell >Voucher Discount ({(order.voucher_discount.type === 'cash') ? 'RM ' + order.voucher_discount.value.toFixed(2) : order.voucher_discount.value + '%'})</Table.HeaderCell>
                                                        <Table.HeaderCell >RM {(-voucherDiscount).toFixed(2)}</Table.HeaderCell>
                                                    </Table.Row>
                                                }

                                                <Table.Row>
                                                    <Table.HeaderCell >Shipping Fee</Table.HeaderCell>
                                                    <Table.HeaderCell >
                                                        <Input
                                                            label={{ basic: true, content: 'RM' }}
                                                            labelPosition='left'
                                                            placeholder='Shipping Fee'
                                                            name='shipping_fee'
                                                            type='number'
                                                            min='0'
                                                            step='0.01'
                                                            onBlur={this.handleShippingFeeChange.bind(this)}
                                                            defaultValue={this.state.shipping_fee}
                                                            required />
                                                    </Table.HeaderCell>
                                                </Table.Row>
                                                <Table.Row>
                                                    <Table.HeaderCell><b>TOTAL AMOUNT</b></Table.HeaderCell>
                                                    <Table.HeaderCell><b>RM {display_total.toFixed(2)}</b></Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Footer>
                                        </Table>
                                        <Button.Group floated='left' > <Button primary onClick={this.handleButton.bind(this, 'productForm')}>Back</Button></Button.Group>
                                        <Button.Group floated='right' >  <Button primary type="submit" disabled={!selected_customer || submitting} >Submit</Button></Button.Group>
                                        <br/><br/>
                                    </Form>
                                </Fragment>

                            )
                        }
                        {
                            ((orderingPage === 'ackForm') &&
                                <Fragment>
                                    <h3>Your submission is successful.</h3>
                                    <Container textAlign='right'><Button primary onClick={() => this.props.openCustomModal(false)}>Done</Button></Container>
                                </Fragment>
                            )
                        }
                    </Modal.Content>
                </Modal>

                {/* Display On Page */}

                {/* Open Booklet / General Modal */}
            </Fragment>
        )
    }
}

const bindopt = [
    { key: 'Saddle Stitch', value: 'Saddle Stitch', text: 'Saddle Stitch' },
    { key: 'Perfect Binding', value: 'Perfect Binding', text: 'Perfect Binding' }
]

// const coveropt = [
//     { key: '230gsm Art Card', value: '230gsm Art Card', text: '230gsm Art Card' },
//     { key: '260gsm Art Card', value: '260gsm Art Card', text: '260gsm Art Card' },
//     { key: 'Others', value: 'Others', text: 'Others' }
// ]

const printopt = [
    { key: '4 Colour Outer Only', value: '4 Colour Outer Only', text: '4 Colour Outer Only' },
    { key: '4 Colour Outer & 4 Colour Inner', value: '4 Colour Outer & 4 Colour Inner', text: '4 Colour Outer & 4 Colour Inner' }
]


// const inneropt = [
//     { key: '80gsm Simili Paper', value: '80gsm Simili Paper', text: '80gsm Simili Paper' },
//     { key: '100gsm Simili Paper', value: '100gsm Simili Paper', text: '100gsm Simili Paper' },
//     { key: '100gsm Gloss Art Paper', value: '100gsm Gloss Art Paper', text: '100gsm Gloss Art Paper' },
//     { key: '128gsm Gloss Art Paper', value: '128gsm Gloss Art Paper', text: '128gsm Gloss Art Paper' },
//     { key: '157gsm Gloss Art Paper', value: '157gsm Gloss Art Paper', text: '157gsm Gloss Art Paper' },
//     { key: '230gsm Art Card', value: '230gsm Art Card', text: '230gsm Art Card' },
//     { key: '260gsm Art Card', value: '260gsm Art Card', text: '260gsm Art Card' },
//     { key: 'Others', value: 'Others', text: 'Others' }
// ]


// General
const paperopt = [
    { key: '80gsm Simili Paper', value: '80gsm Simili Paper', text: '80gsm Simili Paper' },
    { key: '100gsm Simili Paper', value: '100gsm Simili Paper', text: '100gsm Simili Paper' },
    { key: '100gsm Gloss Art Paper', value: '100gsm Gloss Art Paper', text: '100gsm Gloss Art Paper' },
    { key: '128gsm Gloss Art Paper', value: '128gsm Gloss Art Paper', text: '128gsm Gloss Art Paper' },
    { key: '157gsm Gloss Art Paper', value: '157gsm Gloss Art Paper', text: '157gsm Gloss Art Paper' },
    { key: '230gsm Gloss Art Card', value: '230gsm Gloss Art Card', text: '230gsm Gloss Art Card' },
    { key: '260gsm Gloss Art Card', value: '260gsm Gloss Art Card', text: '260gsm Gloss Art Card' },
    { key: '300gsm Gloss Art Card', value: '300gsm Gloss Art Card', text: '300gsm Gloss Art Card' },
    { key: '350gsm Gloss Art Card', value: '350gsm Gloss Art Card', text: '350gsm Gloss Art Card' },
    // { key: 'Others', value: 'Others', text: 'Others' },
]

const colouropt = [
    { key: '4 Colour (Front)', value: '4 Colour (Front)', text: '4 Colour (Front)' },
    { key: '4 Colour (Both)', value: '4 Colour (Both)', text: '4 Colour (Both)' }
]

const laminationopt = [
    { key: 'None', value: 'None', text: 'None' },
    { key: 'Gloss Lamination (Front)', value: 'Gloss Lamination (Both)', text: 'Matte Lamination (Front)' },
    { key: 'Gloss Lamination (Both)', value: 'Gloss Lamination (Both)', text: 'Gloss Lamination (Both)' },
    { key: 'Matte Lamination (Front)', value: 'Matte Lamination (Front)', text: 'Matte Lamination (Front)' },
    { key: 'Matte Lamination (Both)', value: 'Matte Lamination (Both)', text: 'Matte Lamination (Both)' }
]

const opt = [
    { key: 'No', value: 'No', text: 'No' },
    { key: 'Yes', value: 'Yes', text: 'Yes' }
]

const hotstampopt = [
    { key: 'None', value: 'None', text: 'None' },
    { key: '1 Colour (Front)', value: '1 Colour (Front)', text: '1 Colour (Front)' },
    { key: '1 Colour (Back)', value: '1 Colour (Back)', text: '1 Colour (Back)' },
    { key: '2 Colour (Front)', value: '2 Colour (Front)', text: '2 Colour (Front)' },
    { key: '2 Colour (Back)', value: '2 Colour (Back)', text: '2 Colour (Back)' }
]

const shippingopt = [
    { key: 'Self Collect', value: 'Self Collect', text: 'Self Collect' },
    { key: 'Billing Address', value: 'Billing Address', text: 'Ship to Billing Address' },
    { key: 'Shipping Address', value: 'Shipping Address', text: 'Ship to Different Address' }
]

const mapStateToProps = ({ order, sales, customer, product }) => {
    return { order, sales, customer, product }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getOrders: getOrders,
        showLoading: showLoading,
        hideLoading: hideLoading,
        getCustomers: getCustomers,
        getProductMaterials: getProductMaterials,
        verifyVoucher: verifyVoucher,
        clearVoucher: clearVoucher,
        openCustomModal: openCustomModal
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(GetProduct);
